import { cloneDeep } from 'lodash';
import {
    UPDATE_SETUP, UPDATE_NOTIFICATIONS, RESET_INPUT_NOTIFICATIONS, RESET_SETUP,
} from './setup.actions';
import {
    BidProcessType, NotificationType, AdminSidePanelAction, QualificationRule, TimeUnit, AnchorDay,
} from '../../../Enums';

export const noneTemplateId = 'none';
export const defaultTimeValue = 0;
export const defaultTimeUnit = TimeUnit.Hour;

const defaultNotifications = [
    {
        type: NotificationType.willStartNotifIdToManager,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.hasStartedNotifIdToManager,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.willEndNotifIdToManager,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.hasEndedNotifIdToManager,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.autoApprovedNotifIdToManager,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.autoSignOffAndPublishNotifIdToManager,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.preferentialWillStartNotifIdToEmployee,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.preferentialHasStartedNotifIdToEmployee,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.preferentialDraftMadeNotifIdToEmployee,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.sequentialTurnWillStartNotifIdToEmployee,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.sequentialTurnHasStartedNotifIdToEmployee,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.sequentialTurnHasEndedNotifIdToEmployee,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.willEndNotifIdToEmployee,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.hasEndedNotifIdToEmployee,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.approvedNotifIdToEmployee,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.refusedNotifIdToEmployee,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.unawardedNotifIdToEmployee,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.cancelledNotifIdToEmployee,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.rankChangeNotifIdToEmployee,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
    {
        type: NotificationType.removedFromBidNotifIdToEmployee,
        templateId: noneTemplateId,
        timeValue: defaultTimeValue,
        timeUnit: defaultTimeUnit,
    },
];

/** @type {Setup.ISetupDetails} */
const initialState = {
    bidSetupId: '',
    creationDate: '',
    lastUpdate: '',
    name: '',
    description: '',
    creationHyperfindId: undefined,
    managementHyperfindId: undefined,
    viewHyperfindId: undefined,
    scheduleSource: -1,
    bidProcessType: BidProcessType.Preferential, // Defaults to Preferential
    qualificationRule: QualificationRule.None,
    awardingRuleSetId: -1,
    isAutoApproval: false,
    isEmployeeMustSubmitRequiredAmountOfBids: false,
    isEmployeeCanDeclineBid: false,
    isRebidAllowed: false,
    isAllowEmployeesToLockForRebid: false,
    dataviewId: undefined, // Cannot use -1 as default
    dataviewDisplayedCols: [],
    notificationTemplates: cloneDeep(defaultNotifications),
    isUsed: false,
    adminSidePanelAction: AdminSidePanelAction.None,
    anchorDay: AnchorDay.Sunday,
    isOverrideSchedule: false,
    isEnableEmployeeRankReport: false,
    isEnableEmployeeBidResultReport: false,
    isAutoSignOff: false,
    isBidOnBehalfAllowedWhenActive: false,
    isBidOnBehalfAllowedWhenClosed: false,
    isEditBidOnBehalfAllowedWhenActive: false,
    isEditBidOnBehalfAllowedWhenClosed: false,
    isRecalculateEmployeeRanksAllowedWhenActiveOrClosed: false,
    isEditEmployeesWhenBidActive: false,
    isGroupShiftlinesWithSameSchedules: true,
    weeklyHours: false,
    weeklyHoursByDefault: false,
    breakRules: [],
    isAllowBidOnActiveWorkplan: false,
    isEmployeeCanBidAfterAllottedTime: true,
    sequentialBidClosingDelay: 0,
};

/**
 * @param {Setup.ISetupDetails} state
 * @param {ShiftBidding.IAction} action
 * */
// eslint-disable-next-line default-param-last
export function adminSetupReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case UPDATE_SETUP:
            return {
                ...state,
                ...payload,
            };
        case UPDATE_NOTIFICATIONS:
            return {
                ...state,
                notificationTemplates: [
                    ...payload,
                ],
            };
        case RESET_INPUT_NOTIFICATIONS: {
            const notifs = state.notificationTemplates.map((x) => (payload.includes(x.type)
                ? {
                    type: x.type,
                    templateId: noneTemplateId,
                    timeValue: defaultTimeValue,
                    timeUnit: defaultTimeUnit,
                }
                : x));
            return {
                ...state,
                notificationTemplates: [
                    ...notifs,
                ],
            };
        }
        case RESET_SETUP:
            return {
                ...initialState,
                notificationTemplates: cloneDeep(defaultNotifications),
            };
        default:
            return state;
    }
}
